import React, { Component } from "react";
import "./style.css";
import "../../../../../index.css";
import { post } from "../../../../../utils/request";
class ToCollageToolFilterMajor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      markArray: [1, 0],
      userData: [],
      cellName: "删除",
    };
  }

  render() {
    const { cNum, dNum, userCData, userDData } = this.props;
    return (
      <div>
        <div className="to_college_tool_filter_major_switch">
          <div
            onClick={() => this.activateTab(0)}
            className={
              this.state.markArray[0]
                ? "to_college_tool_filter_major_switch_fl font_size_16 blod"
                : "to_college_tool_filter_major_switch_fl "
            }
          >
            <div>候选志愿({cNum})</div>
            <div
              className={
                this.state.markArray[0]
                  ? "to_college_tool_filter_major_line"
                  : "to_college_tool_filter_major_line display_none "
              }
            ></div>
          </div>
          <div
            onClick={() => this.activateTab(1)}
            className={
              this.state.markArray[1]
                ? "to_college_tool_filter_major_switch_fr font_size_16 blod"
                : "to_college_tool_filter_major_switch_fr "
            }
          >
            <div>已删志愿({dNum})</div>
            <div
              className={
                this.state.markArray[1]
                  ? "to_college_tool_filter_major_line"
                  : "to_college_tool_filter_major_line display_none "
              }
            ></div>
          </div>
        </div>
        <div style={{ height: "119px" }}></div>
        <div className="to_college_tool_filter_major_data">
          <table
            border="0"
            cellPadding="0"
            cellSpacing="0"
            className="to_college_tool_filter_major_data_head"
          >
            <tbody>
              <tr>
                <td
                  style={{ fontWeight: "normal", borderLeft: 0, width: "30%",borderBottom: 0, }}
                >
                  大学
                </td>
                <td style={{ fontWeight: "normal", width: "30%", borderLeft: 0,borderBottom: 0, }}>
                  专业/两年分数
                </td>
                <td style={{ fontWeight: "normal", width: "30%", borderLeft: 0,borderBottom: 0, }}>备注</td>
                <td
                  style={{ fontWeight: "normal", borderRight: 0, borderLeft: 0,width: "10%",}}
                >
                  {this.state.cellName}
                </td>
              </tr>
            </tbody>
          </table>
          <div style={{ height: "29px" }}></div>
          <table
            border="0"
            cellPadding="0"
            cellSpacing="0"
            style={{ width: "100%" }}
            className="to_college_tool_filter_major_data_list"
          >
            <tbody>
              {this.state.markArray[0] === 1
                ? userCData.map((major, index) => {
                    return (
                      <tr key={index}>
                        <td
                          style={{
                            width: "30%",
                            borderLeft: 0,
                            borderTop: 0,
                            fontSize:14,
           
                          }}
                        >
                          {" "}
                          {major.schoolName}
                          <br />
                          <div style={{ fontSize: 12, color: "#FE9200" }}>
                            {major.property}
                          </div>
                        </td>
                        <td
                          style={{
                            width: "30%",
                            borderLeft: 0,
                            borderTop: 0,
                            fontSize:14,
                    
                          }}
                        >
                          {major.level === "专科" ? (
                            <img
                              alt=""
                              style={{
                                width: 30,
                                position: "relative",
                                top: "2px",
                                paddingRight: "5px",
                                zIndex: "-999",
                              }}
                              src={require("../../../../../images/tocollege/zhuan.png")}
                            ></img>
                          ) : (
                            ""
                          )}

                          {major.majorName}
                          <br />
                          <div style={{ fontSize: 12, color: "#FE9200" }}>
                            {major.newScore} &nbsp;{major.oldScore}{" "}
                          </div>
                        </td>
                        <td
                          style={{
                            width: "30%",
                            borderLeft: 0,
                            borderTop: 0,
                            fontSize:14,
                            textAlign:'justify',
                            paddingLeft:3,
                            paddingRight:3
                          }}
                        >
                          <img
                            alt=""
                            style={{
                              width: 15,
                              position: "relative",
                              top: "2px",
                              paddingRight: "5px",
                              zIndex: "-999",
                            }}
                            src={require("../../../../../images/tocollege/" +
                              major.upDown +
                              ".png")}
                          ></img>
                          {major.remark}
                        </td>
                        <td
                          onClick={() => this.dealMajor(major.id)}
                          style={{
                            width: "10%",
                            borderLeft: 0,
                            borderTop: 0,
                            borderRight: 0,
                          }}
                        >
                          <img
                            alt=""
                            style={{ width: 15 }}
                            src={
                              this.state.markArray[0]
                                ? require("../../../../../images/tocollege/delete.png")
                                : require("../../../../../images/tocollege/recover.png")
                            }
                          ></img>
                        </td>
                      </tr>
                    );
                  })
                : userDData.map((major, index) => {
                    return (
                      <tr key={index}>
                        <td
                          style={{
                            width: "30%",
                            borderLeft: 0,
                            borderTop: 0,
                            fontSize:14,
                  
                          }}
                        >
                          {" "}
                          {major.schoolName}
                          <br />
                          <div style={{ fontSize: 12, color: "#FE9200" }}>
                            {major.property}
                          </div>
                        </td>
                        <td
                          style={{
                            width: "30%",
                            borderLeft: 0,
                            borderTop: 0,
                            fontSize:14,
                     
                          }}
                        >
                          {major.level === "专科" ? (
                            <img
                              alt=""
                              style={{
                                width: 30,
                                position: "relative",
                                top: "2px",
                                paddingRight: "5px",
                                zIndex: "-999",
                              }}
                              src={require("../../../../../images/tocollege/zhuan.png")}
                            ></img>
                          ) : (
                            ""
                          )}

                          {major.majorName}
                          <br />
                          <div style={{ fontSize: 12, color: "#FE9200" }}>
                            {major.newScore} &nbsp;{major.oldScore}{" "}
                          </div>
                        </td>
                        <td
                          style={{
                            width: "30%",
                            borderLeft: 0,
                            borderTop: 0,
                            fontSize:14,
                            textAlign:'justify',
                            paddingLeft:3,
                            paddingRight:3
                          }}
                        >
                          <img
                            alt=""
                            style={{
                              width: 15,
                              position: "relative",
                              top: "2px",
                              paddingRight: "5px",
                              zIndex: "-999",
                            }}
                            src={require("../../../../../images/tocollege/" +
                              major.upDown +
                              ".png")}
                          ></img>
                          {major.remark}
                        </td>
                        <td
                          onClick={() => this.dealMajor(major.id)}
                          style={{
                            width: "10%",
                            borderLeft: 0,
                            borderTop: 0,
                            borderRight: 0,
                          }}
                        >
                          <img
                            alt=""
                            style={{ width: 15 }}
                            src={
                              this.state.markArray[0]
                                ? require("../../../../../images/tocollege/delete.png")
                                : require("../../../../../images/tocollege/recover.png")
                            }
                          ></img>
                        </td>
                      </tr>
                    );
                  })}
            </tbody>
          </table>
          <div style={{ height: "60px" }}></div>
        </div>
      </div>
    );
  }
  activateTab = (id) => {
    let tmpMarkArray = [0, 0];
    tmpMarkArray[id] = 1;
    if (tmpMarkArray[0] === 1) {
      this.setState({
        markArray: tmpMarkArray,
        cellName: "删除",
      });
    } else {
      this.setState({
        markArray: tmpMarkArray,
        cellName: "恢复",
      });
    }
  };

  dealMajor(majorId) {
    if (this.state.markArray[0] === 1) {
      post("/public/v1/toCollage/user/delete/" + majorId).then((res) => {
        this.props.requestUserData();
      });
    } else {
      post("/public/v1/toCollage/user/recover/" + majorId).then((res) => {
        this.props.requestUserData();
      });
    }
  }
}

export default ToCollageToolFilterMajor;



// WEBPACK FOOTER //
// ./src/containers/ToCollegeTool/ToCollageToolFilter/components/ToCollageToolFilterMajor/index.js